import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { useEffect } from "react";
import MetaTags from "react-meta-tags";
import { notifyPageView } from "../analytics/useAnalyticsEventTracker";
import { stateType } from "../state";
import { BottomBar } from "./BottomBar";
import { BottomButtons } from "./BottomButtons";
import { MainImage } from "./MainImage";
import { ProductFeatures } from "./ProductFeatures";
import { TopBarScroll } from "./TopBarScroll";
import { UseCases } from "./UseCases";

import { setMetaTags } from "../helpers/pageMeta";
const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		container: {
			backgroundColor: "white",
			width: "100vw",

			overflow: "hidden",
		},
	});
});

export function HomePage({ state }: stateType) {
	const classes = useStyles();
	useEffect(() => {
		setMetaTags();
		notifyPageView("Home Page", window.location.pathname);
	}, []);

	return (
		<div className={classes.container}>
			<TopBarScroll></TopBarScroll>
			<MainImage></MainImage>
			<ProductFeatures></ProductFeatures>
			<UseCases state={state}></UseCases>
			<BottomButtons state={state}></BottomButtons>
			<BottomBar state={state}></BottomBar>
		</div>
	);
}
